import { User } from '@/modules/user/user';

import { technicalMessageTypes } from '@shared/common/types/technical-message-types';
import { Device } from '@/modules/device/device';

export class TechnicalMessage {
    public id!: string;
    public date!: Date;
    public type!: string;
    public deviceId!: string;
    public device?: Device;
    public createdAt!: Date;
    public createdBy?: User;

    constructor(opt: any) {
        Object.assign(this, opt);

        if (this.device) {
            this.device = new Device(this.device);
        }
    }

    public get typeLabel(): string {
        const technicalMessageType = technicalMessageTypes.find((tmt) => tmt.id === this.type);

        if (technicalMessageType) {
            return technicalMessageType.label;
        }

        return `Type de message inconnu (${this.type})`;
    }
}
